import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { EditorHtmlField, useSettings, useModel, Utils } from 'app/main/components';

interface CompaniesOrderNotesEditDialogProps {
	model: any;
	updateRefresh: VoidFunction;
}

export const showCompaniesOrderNotesEditDialog = (props: CompaniesOrderNotesEditDialogProps) =>
	openDialog({ children: <CompaniesOrderNotesEditDialog {...props} />, maxWidth: 'sm', fullWidth: true });

export default function CompaniesOrderNotesEditDialog({
	model: baseModel,
	updateRefresh
}: CompaniesOrderNotesEditDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('companies');

	const { model, sendChange, save } = useModel({ baseModel, settings, isEdit: true });

	const addNote = () => {
		save({
			onSuccess: () => {
				Utils.alertSuccessMsg(t);
				dispatch(closeDialog());
				if (updateRefresh) updateRefresh();
			}
		});
	};

	return (
		<>
			<DialogTitle>{t('DIALOG_COMPANIES_ORDERS_NOTES_EDIT')}</DialogTitle>
			<DialogContent>
				<EditorHtmlField
					name="comp_ords_noteshtml"
					value={model.comp_ords_noteshtml}
					sendChange={sendChange}
					isEdit
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={addNote}>
					{t('DIALOG_ACTION_SAVE')}
				</Button>
			</DialogActions>
		</>
	);
}
